<div class="totalContainer">
  <section class="banner text-center">
    <div class="container">
      <div class="row justify-content-md-end justify-content-center">
        <div class="col-lg-4">
          <a
            [routerLink]="'.'"
            [queryParams]="{ reg: referralId }"
            [fragment]="'regform'"
            class="sign_up_button go"
            data-aos="fade-left"
            data-aos="fade-left"
            >Sign Up</a
          >
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="banner-invited">
            <div
              class="invited-by mtf text-white"
              data-aos="fade-down"
              data-aos-delay="400"
            >
              <p class="font-weight-light mb-2" data-aos="fade-down">
                You Are Invited By
              </p>
              <h5 class="font-weight-bold mb-0 ml15">
                <span class="word"></span>
                <span class="word"></span>
                <span class="word">{{ userName }}</span>
              </h5>
            </div>

            <div
              class="hands-area d-inline-block position-relative"
              data-aos="zoom-in"
            >
              <img
                src="{{ myLinksS3URL }}frontend/presentation16/images/hand1.png"
                alt=""
                class="img-fluid hands hand1"
              />

              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation16/images/element.png"
                alt=""
                class="img-fluid box-image"
              />

              <p class="text-uppercase text-white lato ml12">
                Let us make our future now, and let us make our dreams
                tomorrow's reality
              </p>

              <img
                src="{{ myLinksS3URL }}frontend/presentation16/images/hand2.png"
                alt=""
                class="img-fluid hands hand2"
              />
            </div>

            <h2 class="mtf ml2" data-aos="fade-up">
              Here is the magical solution to <br />
              fulfill your dreams.
            </h2>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="sec_two">
    <div class="container">
      <div class="row">
        <div class="col-lg-7">
          <div class="sec_two_left_box">
            <div class="sec_two_left_image" data-aos="fade-left">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation16/images/sec_two_left_image.png"
                class="img-fluid"
                alt="image"
              />
            </div>
            <h1 data-aos="fade-right">
              Welcome to <br />
              <span>O-FOUNDERS.</span>
            </h1>
            <p data-aos="fade-left">
              Our breakthrough solution has everything you need to make money so
              that you can start replacing your income quickly.
            </p>
            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
              class="become_button"
              data-aos="zoom-in"
              ><span>Become A Founder Now </span></a
            >
          </div>
        </div>
        <div class="col-lg-5">
          <div class="sec_two_right_box">
            <div class="sec_two_first_box">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation16/images/image_one.jpg"
                class="img-fluid"
                alt="image"
                data-aos="flip-left"
              />
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation16/images/image_two.jpg"
                class="img-fluid"
                alt="image"
                data-aos="flip-up"
              />
            </div>
            <div class="sec_two_sec_box">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation16/images/image_three.jpg"
                class="img-fluid"
                alt="image"
                data-aos="flip-down"
              />
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation16/images/image_four.jpg"
                class="img-fluid"
                alt="image"
                data-aos="flip-right"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="sec_three">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="banner-invited" data-aos="zoom-in">
            <div class="hands-area d-inline-block position-relative">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation16/images/element_two.png"
                alt=""
                class="img-fluid box-image"
              />

              <h2>WIN BIG IN 2020</h2>

              <!--<h4 class="text-uppercase text-white lato">THE CONCEPT OF WORKING AND EARNING ONLINE IS NOW A REALITY.</h4>-->
              <h6 class="text-white lato">
                This system is a unique gift and you have been invited to this
                site so that you have the opportunity to absolutely change your
                life for the Better!
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="sec_four">
    <div class="container">
      <div class="row justify-content-between">
        <div class="col-lg-6">
          <div class="sec_four_left_box">
            <h1 data-aos="fade-down">
              Looking for the goldmine of residual income?
            </h1>
            <div class="video_one_box" data-aos="zoom-in">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation16/images/video_image_one.png"
                class="img-fliud"
                alt="image"
              />
              <div class="play_button">
                <a
                  href="#"
                  data-toggle="modal"
                  data-backdrop="static"
                  data-keyboard="false"
                  data-target="#myModal1"
                  ><img
                    src="{{
                      myLinksS3URL
                    }}frontend/presentation16/images/play_buton.jpg"
                    class="img-fliud"
                    alt="image"
                /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5">
          <div class="sec_four_right_box">
            <p data-aos="fade-down">
              Autopilot your existing business and enjoy the benefits:
            </p>
            <div
              class="sec_four_right_first_box"
              data-aos="fade-right"
              data-aos-duration="200"
            >
              Getting unique leads
            </div>
            <div
              class="sec_four_right_first_box"
              data-aos="fade-right"
              data-aos-duration="600"
            >
              Fresh signups everyday
            </div>
            <div
              class="sec_four_right_first_box"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              Rotating limitless websites
            </div>
            <div
              class="sec_four_right_first_box"
              data-aos="fade-right"
              data-aos-duration="1400"
            >
              Endless forced traffic
            </div>
            <div
              class="sec_four_right_first_box"
              data-aos="fade-right"
              data-aos-duration="1800"
            >
              Seamless conversion & closing
            </div>
            <div
              class="sec_four_right_first_box"
              data-aos="fade-right"
              data-aos-duration="1200"
            >
              Virally created spillover
            </div>
            <p data-aos="fade-up">
              We welcome big dreamers to learn about our innovative business
              strategy and witness the magic.
            </p>
            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
              class="become_button_two"
              data-aos="zoom-in"
              ><span>Become A Founder Now </span></a
            >
          </div>
        </div>
      </div>

      <div class="row justify-content-between">
        <div class="col-lg-5">
          <div class="sec_four_right_box">
            <h1 data-aos="fade-right">
              Redefining the power of the internet and the concept of working
              from home!
            </h1>
            <p data-aos="fade-left">
              Our ultimate technology to help you flip the meaning of success!
              Automation on:
            </p>
            <div
              class="sec_four_right_first_box_bottom"
              data-aos="fade-right"
              data-aos-duration="200"
            >
              Advertising
            </div>
            <div
              class="sec_four_right_first_box_bottom"
              data-aos="fade-right"
              data-aos-duration="600"
            >
              Marketing
            </div>
            <div
              class="sec_four_right_first_box_bottom"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              Recruiting
            </div>
            <div
              class="sec_four_right_first_box_bottom"
              data-aos="fade-right"
              data-aos-duration="1400"
            >
              Team Building
            </div>
            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
              class="become_button_two"
              data-aos="zoom-in"
              ><span>Become A Founder Now </span></a
            >
          </div>
        </div>

        <div class="col-lg-6">
          <div class="sec_four_left_box">
            <div class="video_one_box" data-aos="zoom-in">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation16/images/video_image_two.png"
                class="img-fliud"
                alt="image"
              />
              <div class="play_button">
                <a
                  href="#"
                  data-toggle="modal"
                  data-backdrop="static"
                  data-keyboard="false"
                  data-target="#myModal2"
                  ><img
                    src="{{
                      myLinksS3URL
                    }}frontend/presentation16/images/play_buton.jpg"
                    class="img-fliud"
                    alt="image"
                /></a>
              </div>
            </div>
            <h2>What is stopping you?</h2>
            <p>
              $97 is all you need to join in the miraculous marketing process
              which will otherwise cost you $997. Join the journey before the
              seats run out.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="sec_five">
    <div class="container">
      <div class="row justify-content-between">
        <div class="col-lg-6">
          <div class="sec_five_video" data-aos="zoom-in">
            <img
              src="{{
                myLinksS3URL
              }}frontend/presentation16/images/video_image_three.png"
              class="img-fluid"
              alt="image"
            />
            <div class="play_button">
              <a
                href="#"
                data-toggle="modal"
                data-backdrop="static"
                data-keyboard="false"
                data-target="#myModal3"
                ><img
                  src="{{
                    myLinksS3URL
                  }}frontend/presentation16/images/play_buton.jpg"
                  class="img-fliud"
                  alt="image"
              /></a>
            </div>
          </div>
          <a
            [routerLink]="'.'"
            [queryParams]="{ reg: referralId }"
            [fragment]="'regform'"
            class="become_button_two"
            data-aos="zoom-in"
            ><span>Become A Founder Now </span></a
          >
        </div>
        <div class="col-lg-5">
          <div class="sec_five_right_box">
            <h1 data-aos="fade-left">Register with us in two steps:</h1>
            <div class="row">
              <div class="col-lg-6">
                <div class="sec_five_first_box" data-aos="fade-right">
                  <div class="sec_five_first_box_left_image">
                    <img
                      src="{{
                        myLinksS3URL
                      }}frontend/presentation16/images/left_image.png"
                      class="img-fluid"
                      alt="image"
                    />
                  </div>
                  <p>Fill in your details and register on O-Founders</p>
                  <div class="sec_five_first_box_right_image">
                    <img
                      src="{{
                        myLinksS3URL
                      }}frontend/presentation16/images/right_image.png"
                      class="img-fluid"
                      alt="image"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="sec_five_first_box" data-aos="fade-left">
                  <div class="sec_five_first_box_left_image">
                    <img
                      src="{{
                        myLinksS3URL
                      }}frontend/presentation16/images/left_image.png"
                      class="img-fluid"
                      alt="image"
                    />
                  </div>
                  <p>
                    Complete the necessary payments and secure your position
                  </p>
                  <div class="sec_five_first_box_right_image">
                    <img
                      src="{{
                        myLinksS3URL
                      }}frontend/presentation16/images/right_image.png"
                      class="img-fluid"
                      alt="image"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <h4 data-aos="fade-up">Join us today...</h4>
                <h6 data-aos="fade-down">
                  You don't need technical ability to be on the top!
                </h6>
                <h3 data-aos="fade-right">
                  Get on board to build your own page. Invite prospects and
                  construct your team. Inspire everyone to join and help them be
                  a part of the incredible global business project. We will
                  avail you every resource to reach the top.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="sec_six">
    <div class="row">
      <div class="col-lg-7 webiner_bg text-center">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <div class="web_mid_box" data-aos="zoom-in">
              <div class="web_mid_left_image">
                <img
                  src="{{
                    myLinksS3URL
                  }}frontend/presentation16/images/web_left_image.png"
                  class="img-fluid"
                  alt="image"
                />
              </div>
              <h1>WEBI<span>NAR</span></h1>
              <p>PREVIOUS WEBINAR PLAYBACK</p>
              <div class="web_mid_right_image">
                <img
                  src="{{
                    myLinksS3URL
                  }}frontend/presentation16/images/web_right_image.png"
                  class="img-fluid"
                  alt="image"
                />
              </div>
              <a
                href="#"
                data-toggle="modal"
                data-backdrop="static"
                data-keyboard="false"
                data-target="#previous"
                class="web_play_button"
                ><img
                  src="{{
                    myLinksS3URL
                  }}frontend/presentation16/images/web_play_button.png"
                  class="img-fluid"
                  alt="image"
                />
              </a>
            </div>
            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
              class="become_button_two"
              data-aos="zoom-in"
              ><span>Become A Founder Now </span></a
            >
          </div>
        </div>
      </div>
      <div class="col-lg-5">
        <div class="sec_six_right_box">
          <h1 data-aos="fade-right">
            Do not let go of this extraordinary opportunity
          </h1>
          <!--<p data-aos="fade-left">Life Is About To Get Better</p>-->
          <ul>
            <li data-aos="fade-right">
              It doesn't matter where you live or how old you are.
            </li>
            <li data-aos="fade-right">
              It doesn't matter how educated you are.
            </li>
            <li data-aos="fade-right">
              It doesn't matter how much money you have.
            </li>
            <li data-aos="fade-right">
              It doesn't matter what skills or experience you have.
            </li>
          </ul>
          <h4 data-aos="fade-up">"You'll Want To Be In It To Win It!"</h4>
          <a
            [routerLink]="'.'"
            [queryParams]="{ reg: referralId }"
            [fragment]="'regform'"
            class="become_button_two"
            data-aos="zoom-in"
            ><span>Become A Founder Now </span></a
          >
        </div>
      </div>
    </div>
  </div>

  <div class="reg_bg" data-aos="fade-up" data-aos-duration="1500" id="regform">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1>REGISTER</h1>
        </div>
      </div>

      <div class="panel-group cst"></div>

      <form [formGroup]="registerForm">
        <div class="row reg">
          <div class="col-md-6">
            <div class="d-block form-group">
              <input
                matInput
                type="text"
                class="log_in_fild form-control"
                placeholder="First Name"
                formControlName="firstname"
                required
              />
              <span
                *ngIf="
                  registerForm.controls['firstname'].hasError('required') &&
                  registerForm.controls['firstname'].touched
                "
                class="failed-validation"
                style="color: red"
              >
                First Name Required.
              </span>
              <span
                *ngIf="registerForm.controls['firstname'].hasError('maxlength')"
                class="failed-validation"
                style="color: red"
              >
                Min 1, max 50 characters.
              </span>

              <span
                *ngIf="
                  registerForm.controls['firstname'].hasError(
                    'containOnlyNumbers'
                  )
                "
                class="failed-validation"
                style="color: red"
              >
                Only numbers are not allowed.
              </span>

              <span
                *ngIf="
                  registerForm.controls['firstname'].hasError(
                    'containOnlySpecialChars'
                  )
                "
                class="failed-validation"
                style="color: red"
              >
                Only special characters are not allowed.
              </span>

              <span
                *ngIf="
                  registerForm.controls['firstname'].hasError(
                    'containConsecutiveSpaces'
                  )
                "
                class="failed-validation"
                style="color: red"
              >
                Consecutive spaces are not allowed.
              </span>

              <span
                *ngIf="
                  registerForm.controls['firstname'].hasError(
                    'containConsecutiveDots'
                  )
                "
                class="failed-validation"
                style="color: red"
              >
                Consecutive dots are not allowed.
              </span>

              <span
                *ngIf="
                  registerForm.controls['firstname'].hasError(
                    'containConsecutiveHyphens'
                  )
                "
                class="failed-validation"
                style="color: red"
              >
                Consecutive dashes are not allowed.
              </span>

              <span
                *ngIf="
                  registerForm.controls['firstname'].hasError(
                    'containConsecutiveUnderScores'
                  )
                "
                class="failed-validation"
                style="color: red"
              >
                Consecutive underscores are not allowed.
              </span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-block form-group">
              <input
                matInput
                type="text"
                placeholder="Last Name"
                class="log_in_fild form-control"
                formControlName="lastname"
                required
              />
              <span
                *ngIf="
                  registerForm.controls['lastname'].hasError('required') &&
                  registerForm.controls['lastname'].touched
                "
                class="failed-validation"
                style="color: red"
              >
                Last Name Required.
              </span>
              <span
                *ngIf="registerForm.controls['lastname'].hasError('maxlength')"
                class="failed-validation"
                style="color: red"
              >
                Min 1, max 50 characters.
              </span>
              <span
                *ngIf="
                  registerForm.controls['lastname'].hasError(
                    'containOnlyNumbers'
                  )
                "
                class="failed-validation"
                style="color: red"
              >
                Only numbers are not allowed.
              </span>
              <span
                *ngIf="
                  registerForm.controls['lastname'].hasError(
                    'containOnlySpecialChars'
                  )
                "
                class="failed-validation"
                style="color: red"
              >
                Only special characters are not allowed.
              </span>
              <span
                *ngIf="
                  registerForm.controls['lastname'].hasError(
                    'containConsecutiveSpaces'
                  )
                "
                class="failed-validation"
                style="color: red"
              >
                Consecutive spaces are not allowed.
              </span>
              <span
                *ngIf="
                  registerForm.controls['lastname'].hasError(
                    'containConsecutiveDots'
                  )
                "
                class="failed-validation"
                style="color: red"
              >
                Consecutive dots are not allowed.
              </span>
              <span
                *ngIf="
                  registerForm.controls['lastname'].hasError(
                    'containConsecutiveHyphens'
                  )
                "
                class="failed-validation"
                style="color: red"
              >
                Consecutive dashes are not allowed.
              </span>
              <span
                *ngIf="
                  registerForm.controls['lastname'].hasError(
                    'containConsecutiveUnderScores'
                  )
                "
                class="failed-validation"
                style="color: red"
              >
                Consecutive underscores are not allowed.
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="d-block form-group">
              <input
                matInput
                type="text"
                placeholder="Email Address"
                class="log_in_fild form-control"
                formControlName="email"
                required
              />

              <span
                *ngIf="
                  registerForm.controls['email'].hasError('required') &&
                  registerForm.controls['email'].touched
                "
                class="failed-validation"
                style="color: red"
              >
                Email id Required.
              </span>
              <span
                *ngIf="registerForm.controls['email'].hasError('pattern')"
                class="failed-validation"
                style="color: red"
              >
                Please enter valid email.
              </span>
              <!-- <span *ngIf="registerForm.controls['email'].hasError('maxLength')" 
                               class="failed-validation" style="color: red">
                                Email length sould be less than 100.
                              </span>-->
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group d-block">
              <div class="password-block">
                <input
                  matInput
                  placeholder="Password"
                  formControlName="password"
                  class="log_in_fild form-control"
                  [type]="pwdToggle ? 'text' : 'password'"
                  required
                />
                <button
                  type="button"
                  class="password-icon"
                  (click)="pwdToggle = !pwdToggle"
                >
                  <i
                    class="fal"
                    [ngClass]="{
                      'fa-eye': pwdToggle,
                      'fa-eye-slash': !pwdToggle
                    }"
                  ></i>
                </button>
              </div>
              <span
                *ngIf="
                  registerForm.controls['password'].hasError('required') &&
                  registerForm.controls['password'].touched
                "
                class="failed-validation"
                style="color: red"
              >
                Password Required
              </span>
              <span
                *ngIf="registerForm.controls['password'].hasError('pattern')"
                class="failed-validation"
                style="color: red"
              >
                Password should contain minimum 8 Characters and Atleast one
                Uppercase, One Lowercase, one Number and one Special Characters
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="d-block form-group">
              <input
                matInput
                type="text"
                placeholder="Phone Number"
                class="log_in_fild form-control"
                formControlName="phone"
                onKeyPress="if(this.value.length==20) return false;"
                onkeydown="return event.keyCode !== 69"
                required
              />
              <span
                *ngIf="
                  registerForm.controls['phone'].hasError('required') &&
                  registerForm.controls['phone'].touched
                "
                class="failed-validation"
                style="color: red"
              >
                Phone number is required.
              </span>
              <span
                *ngIf="registerForm.controls['phone'].hasError('pattern')"
                class="failed-validation"
                style="color: red"
              >
                Only numbers are allowed.
              </span>
              <span
                *ngIf="
                  registerForm.controls['phone'].hasError('minlength') ||
                  registerForm.controls['phone'].hasError('maxlength')
                "
                class="failed-validation"
                style="color: red"
              >
                Min 6 and max 20 digits.
              </span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-block form-group">
              <select
                formControlName="country_id"
                required
                class="log_in_fild form-control"
              >
                <option value="">Select Country</option>
                <option
                  *ngFor="let country of countriesList"
                  [value]="country.countryId"
                >
                  {{ country.countryName }}
                </option>
              </select>
              <span
                *ngIf="
                  registerForm.controls['country_id'].hasError('required') &&
                  registerForm.controls['country_id'].touched
                "
                class="failed-validation"
                style="color: red"
              >
                Plese Select Country
              </span>
            </div>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <div class="row no-gutters">
                <div class="capcha form-control">
                  <img [src]="imageCaptcha" style="width: 150px" />
                </div>

                <div class="refresh-icn">
                  <i
                    class="fa fa-refresh fa-lg"
                    aria-hidden="true"
                    (click)="regenerateCaptcha()"
                  ></i>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="main input-effect">
                <input
                  id="capcha"
                  maxlength="5"
                  name="capcha"
                  type="text"
                  formControlName="enteredCaptcha"
                  placeholder=" Enter Captcha"
                  class="form-control effect-19"
                  required="required"
                />
                <span
                  *ngIf="
                    registerForm.controls['enteredCaptcha'].hasError(
                      'required'
                    ) && registerForm.controls['enteredCaptcha'].touched
                  "
                  class="failed-validation"
                  style="color: red"
                >
                  Captcha Required
                </span>
              </div>
            </div>
          </div>
        </div> -->
        <div class="text-center">
          <button
            mat-raised-button
            type="submit"
            (click)="submitRegister()"
            [disabled]="registerForm.invalid"
            class="ibtn w-100"
          >
            SignUp
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="testimonials_sec">
    <div class="row">
      <div class="col-lg-6 tes_left_bg" data-aos="fade-right"></div>
      <div class="col-lg-6">
        <div class="tes_right_box">
          <!--TESTIMONIALS PART OPEN-->

          <div class="testimonial-container">
            <div class="dk-container">
              <div class="cd-testimonials-wrapper cd-container">
                <div class="cd-testimonials">
                  <ngx-slick-carousel
                    class="carousel"
                    #slickModal="slick-carousel"
                    [config]="slideConfig"
                    (init)="slickInit($event)"
                  >
                    <div ngxSlickItem class="testimonial-content">
                      <h2>An ideal model for anyone</h2>
                      <p>
                        His drive and passion for creating a platform to help
                        everyone from seasoned marketers to the "little guy"
                        helped solidify my belief Then learning how we benefit
                        financially with optional starting points, makes this an
                        ideal model for anyone with a business who needs
                        advertising.
                      </p>

                      <p>
                        Thank you Ash for your vision and help for so many
                        people around the world.
                      </p>

                      <div class="cd-author">
                        <img
                          src="{{ cloudFrontUrl }}uploads/t1.png"
                          alt="Author image"
                        />

                        <ul class="cd-author-info">
                          <li>Tim <strong>Leach</strong></li>

                          <li></li>
                        </ul>
                      </div>
                    </div>

                    <div ngxSlickItem class="testimonial-content">
                      <h2>This Will Undoubtedly Change Your Life!</h2>
                      <p>
                        I want to personally say thank you to everyone on this
                        awesome journey that Ash Murareh has created. As many of
                        you may not know, Ash is a very successful online
                        marketer and has made his living in this industry
                        building massive teams for various companies. He saw a
                        big need for creating a company that would help the
                        average person succeed online so he decided to build it
                        himself.
                      </p>

                      <p>
                        When you listen to his Founder's presentations or when
                        you speak with him, you will immediately feel his
                        passion to build a highly effective business where every
                        single person will be successful.
                      </p>

                      <div class="cd-author">
                        <img
                          src="{{ cloudFrontUrl }}uploads/t4.png"
                          alt="Author image"
                        />

                        <ul class="cd-author-info">
                          <li>Mike <strong>Williams</strong></li>

                          <li></li>
                        </ul>
                      </div>
                    </div>

                    <div ngxSlickItem class="testimonial-content">
                      <h2>
                        I am totally blown away and will build my final dynasty
                        here in ONPASSIVE
                      </h2>
                      <p>
                        In my 19 years successful career in this space,I have
                        never seen a business so full, so disruptive, so
                        intriguing that everyone I approach is excited to
                        belong.
                      </p>

                      <p>
                        Did a Facebook post, alongside my WhatsApp campaign, on
                        the founder position, that attracted 122 comments, 14
                        people have joined direct to me and in less than 48
                        hours, 59 super qualified leads have submitted their
                        email, requesting information to be founders, AND ALL
                        THESE WITHOUT ANYTHING YET ONGROUND, not even a website.
                        I am totally blown away and will build my final dynasty
                        here in ONPASSIVE.
                      </p>

                      <div class="cd-author">
                        <img
                          src="{{ cloudFrontUrl }}uploads/t2.png"
                          alt="Author image"
                        />

                        <ul class="cd-author-info">
                          <li>PRINCE <strong>OBI</strong></li>

                          <li></li>
                        </ul>
                      </div>
                    </div>
                  </ngx-slick-carousel>
                </div>
              </div>

              <!-- cd-testimonials -->
            </div>
          </div>

          <!--TESTIMONIALS PART CLOSED-->
        </div>
      </div>
    </div>
  </div>

  <div class="footer">
    <div class="container">
      <div class="row justify-content-center text-center">
        <div class="col-lg-12">
          <h1>Join In to Win! Act for an impact!</h1>
          <h6>Copyright &copy; 2022 All rights reserved | by O-Founders</h6>
        </div>
      </div>
    </div>
  </div>

  <div id="myModal1" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->

      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            id="first_video_pause"
            class="close"
            data-dismiss="modal"
            (click)="video1.pause(); video1.currentTime = 0"
          >
            &times;
          </button>
        </div>

        <video
          #video1
          id="my-video"
          class="video-js"
          controls
          preload="auto"
          poster="{{
            myLinksS3URL
          }}frontend/invitationfive/images/greeting1-new.png"
        >
          <source
            src="{{ myLinksS3URL }}videos/video1-compressed-new.mp4"
            type="video/mp4"
          />

          <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading
            to a web browser that
            <a
              href="https://videojs.com/html5-video-support/"
              target="_blank"
              rel="noopener"
              >supports HTML5 video</a
            >
          </p>
        </video>
      </div>
    </div>
  </div>

  <div id="myModal2" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->

      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            id="second_video_pause"
            class="close"
            data-dismiss="modal"
            (click)="video2.pause(); video2.currentTime = 0"
          >
            &times;
          </button>
        </div>

        <video
          #video2
          id="my-video1"
          class="video-js"
          controls
          preload="auto"
          poster="{{
            myLinksS3URL
          }}frontend/greetingsgofound/images/greeting2.png"
        >
          <source
            src="{{ myLinksS3URL }}videos/Video2-Compressed-new.mp4"
            type="video/mp4"
          />

          <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading
            to a web browser that
            <a
              href="https://videojs.com/html5-video-support/"
              target="_blank"
              rel="noopener"
              >supports HTML5 video</a
            >
          </p>
        </video>
      </div>
    </div>
  </div>

  <div id="myModal3" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->

      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            id="third_video_pause"
            class="close"
            data-dismiss="modal"
            (click)="video3.pause(); video3.currentTime = 0"
          >
            &times;
          </button>
        </div>

        <video
          #video3
          id="my-video2"
          class="video-js"
          controls
          preload="auto"
          poster="{{
            myLinksS3URL
          }}frontend/invitationfive/images/greeting3-new.png"
        >
          <source
            src="{{
              myLinksS3URL
            }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
            type="video/mp4"
          />

          <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading
            to a web browser that
            <a
              href="https://videojs.com/html5-video-support/"
              target="_blank"
              rel="noopener"
              >supports HTML5 video</a
            >
          </p>
        </video>
      </div>
    </div>
  </div>

  <div id="previous" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->

      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            id="prev_video_pause"
            (click)="video4.pause(); video4.currentTime = 0"
          >
            &times;
          </button>
        </div>

        <video
          #video4
          width="100%"
          class="video-js"
          controls
          preload="auto"
          poster="{{ myLinksS3URL }}videos/title.jpg"
          id="my-video"
        >
          <source
            src="{{
              myLinksS3URL
            }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
            id="video"
            type="video/mp4"
          />

          Your browser does not support HTML5 video.
        </video>
      </div>
    </div>
  </div>

  <div class="country_popup_wrapper"></div>
</div>
